<script setup>
import { computed } from 'vue';
import { Bar } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

const props = defineProps({
  topics: { type: Array, default: () => [] },
});

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

const top = computed(() => props.topics.slice(0, 10));
const chartData = computed(() => ({
  labels: top.value.map(t => t.topic),
  datasets: [
    {
      label: 'Positivo',
      data: top.value.map(t => t.positive),
      backgroundColor: '#059669',
    },
    {
      label: 'Negativo',
      data: top.value.map(t => t.negative),
      backgroundColor: '#dc2626',
    },
    {
      label: 'Neutro',
      data: top.value.map(t => t.neutral),
      backgroundColor: '#94a3b8',
    },
  ],
}));

const options = {
  indexAxis: 'y',
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { position: 'bottom' } },
  scales: {
    x: { stacked: true, beginAtZero: true, ticks: { precision: 0 } },
    y: { stacked: true },
  },
};
</script>

<template>
  <div class="rounded-xl border border-n-weak bg-n-background p-4">
    <h3 class="mb-3 text-sm font-semibold text-n-slate-12">
      Distribuição de Temas
    </h3>
    <div class="h-64">
      <Bar v-if="top.length" :data="chartData" :options="options" />
      <div
        v-else
        class="flex h-full items-center justify-center text-sm text-n-slate-11"
      >
        Sem dados.
      </div>
    </div>
  </div>
</template>
